'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var salesImages = require.context('bender-url!salesImages', true);

var getStaticAsset = {
  fromSalesImages: function fromSalesImages(path) {
    return salesImages('./' + path);
  }
};

exports.default = getStaticAsset;
module.exports = exports['default'];